<template>
  <div id="serviceHallByMatter">
    <div ref="headerHeight" class="header">
      <Search class="flex1" showIcon="true" @onSearchInput="onSearchInput" @setKeyword="setKeyword" :keyword='params.keyword'></Search>
      <van-icon class="filter-btn iconfont" class-prefix="icon" name="shaixuan" color="#ffffff" size="20px"
                @click="showFilter"/>
    </div>
    <div class="flex-between portrait" v-if="themeParams && !(themeParams.hallListModel == 1)">
      <div class="sidebar">
        <div class="sidebar-fixed">
          <van-sidebar v-model="activeKey" @change="onChange">
            <van-sidebar-item title="全部事项"/>
            <van-sidebar-item v-for="(item,index) in serviceTypes" :key="index" :title="item.typeName"/>
          </van-sidebar>
        </div>
      </div>
      <div class="list portrait-list flex1" v-if="!emptyShow">
<!--          <van-pull-refresh v-model="loading" @refresh="onRefresh" :head-height="headerHeight">-->
<!--            <p class="setHeight"></p>-->
            <van-list
                v-model="loading"
                loading-text="正在加载中..."
                :finished="finished"
                @load="onLoad"
                :immediate-check="false"
                finished-text="没有更多了"
            >
              <div class="s-grid-box">
                <ServiceItemPortrait v-for="(item,index) in list" :key="index" :service="item"/>
              </div>
            </van-list>
<!--          </van-pull-refresh>-->
      </div>
      <div class="empty-container" v-else>
        <Error type="empty"/>
      </div>
    </div>
    <div class="landscape" v-else>
      <div class="list landscape-list flex1" v-if="!emptyShow">
<!--        <van-pull-refresh v-model="loading" @refresh="onRefresh" :head-height="headerHeight">-->
<!--          <p class="setHeight"></p>-->
          <van-list
              v-model="loading"
              loading-text="正在加载中..."
              :finished="finished"
              @load="onLoad"
              :immediate-check="false"
              finished-text="没有更多了"
              v-if="list.length>0"
          >
            <ServiceItemLandscape v-for="(item,index) in list" :key="index" :service="item"/>
          </van-list>
<!--        </van-pull-refresh>-->
      </div>
      <div class="empty-container" v-else>
        <Error type="empty"/>
      </div>
    </div>
  </div>
</template>

<script>

import {Sidebar, SidebarItem, Sticky, PullRefresh, List, Toast} from 'vant';
import {queryServiceObjects, queryServiceWays, queryServiceTypes, queryServiceDepts,queryServices} from "@/api/service-hall"
import {mapState} from "vuex"
import http from "@/utils/http";
import {getThemeParams} from "@/utils/theme";
export default {
  name: 'ServiceHall',
  components: {
    Search: () => import("@/components/ServiceHall/Search"),
    ServiceItemPortrait: () => import("@/components/ServiceHall/ServiceItemPortrait"),
    ServiceItemLandscape: () => import("@/components/ServiceHall/ServiceItemLandscape"),
    [Sidebar.name]:Sidebar,
    [SidebarItem.name]:SidebarItem,
    [Sticky.name]:Sticky,
    [PullRefresh.name]:PullRefresh,
    [List.name]:List
  },
  data() {
    return {
      activeKey:0,
      serviceHallListModel:getThemeParams('hallListModel') === "1",//1为列表模式 0为名片模式
      themeParams: null,
      list: [],//列表显示的数据
      loading: false,
      finished: false,
      isLoading: false,
      totalPage: 0,
      headerHeight: 0,
      filterShow:false,
      emptyShow: false //空空如也是否显示
    }
  },
  computed: {
    ...mapState(['serviceTypes','serviceParams']),
    params(){
      let params = {
        pageSize: this.serviceHallListModel? 10 : 30,//列表模式一屏6条，名片模式一屏30条
        pageIndex: 0
      };
      return Object.assign(params,this.serviceParams);
    }
  },
  mounted() {
    this.headerHeight = this.$refs.headerHeight.offsetHeight;
    this.params.publisher = this.$route.query.deptId? this.$route.query.deptId : undefined;
    this.onLoad();
  },
  created() {
    http.get('/nonlogin/basic/getInfo.htm').then(resp=>{
      if (!resp || resp.code != 200) Toast(`获取模板参数失败`)
      if(resp.data){
        this.themeParams = resp.data;
      }
    })
    queryServiceObjects().then(res => {
      this.$store.commit("updateServiceObjects", res.data);
    });
    queryServiceWays().then(res => {
      this.$store.commit("updateServiceWays", res.data);
    });
    queryServiceTypes().then(res => {
      this.$store.commit("updateServiceTypes", res.data);
      this.serviceTypes.filter((item,index)=>{
        if(item.id === this.serviceParams.type){
          this.activeKey = index + 1;
        }
      });
    });
    queryServiceDepts().then(res => {
      this.$store.commit("updateServiceDepts", res.data);
    });
    this.$nextTick(() => {
      if(this.serviceParams.publisher || this.$route.query.deptId){
        if(this.$route.query.deptId){
          this.serviceParams.publisher = this.$route.query.deptId;
          this.$store.commit("updateServiceParams", this.serviceParams);
        }
      }
    })
  },
  methods: {
    onLoad() {
      let that = this;
      let list = this.list;
      if (!that.finished) {
        this.loading = true;
        let params = this.params;
        params.useType = '2';
        queryServices(params).then(res => {
          let result = res.data;
          that.list = list.concat(result.data);
          that.totalPage = result.totalPage;
          that.loading = false;
          if (that.params.pageIndex >= that.totalPage) {
            that.finished = true;
          } else {
            if(result.total >= this.params.pageSize) {
              that.finished = false;
            } else {
              that.finished = true;
            }
            that.params.pageIndex++;
          }
          if (this.list.length > 0) {
            this.emptyShow = false;
          } else {
            this.emptyShow = true;
          }
        });
      }
    },
    //下拉刷新
    onRefresh() {
      this.loading = true;
      this.finished = false;
      this.list = [];
      this.params.pageIndex = 0;
      this.onLoad();
    },
    //切换sidebar
    onChange(index) {
      if (document.getElementsByClassName('list').length>0) {
        document.getElementsByClassName('list')[0].scrollIntoViewIfNeeded(false)
      }
      this.params.type = index > 0 ? this.serviceTypes[index - 1].id : undefined;
      this.activeKey = index;
      this.onRefresh();
    },
    //显示筛选
    showFilter(show) {
      this.$router.push('/homeTab/serviceHall/filter');
    },
    //合并筛选条件参数
    mergeFilterParams(params){
      if(params){
        this.params = Object.assign(this.params,params);
      }
    },
    //获取搜索关键词
    onSearchInput(val){
      let params = this.serviceParams;
      params.keyword = val;
      this.$store.commit("updateServiceParams", params);
      this.onRefresh();
    },
    //搜索组件修改当前页面的keyword
    setKeyword(keyword){
      this.params.keyword = keyword;
      this.$store.commit("updateServiceParams", this.params);
    },
    getThemeParams
  },
}
</script>

<style scoped lang="scss">
@import "~@/assets/css/theme/theme.scss";
#htapp{
  background: #ffffff;
}
.header {
  background: var(--main-color);
  padding: 10px;
  display:flex;
  flex-direction:row;
  justify-content:space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
}
.filter-btn{
  margin-left:10px;
}
.setHeight {
  height: 50px;
}
.portrait{
  display: block !important;
  min-height: 100vh;
  background: #ffffff;
  box-sizing: border-box;
  padding-left: 88px;
  .sidebar {
    width: 88px;
    background: #F7F7F7;
    position:fixed;
    left:0;
    top:50px;
    bottom: 50px;
    z-index: 200;
    overflow-y: auto;
    .sidebar-fixed{
      width:inherit;
    }
    .van-sidebar{
      width:88px;
      background: inherit;
    }
    .van-sidebar-item {
      height: 56px;
      background: inherit;
      display: -webkit-box;
      overflow: hidden;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      padding:24px 5px;
      text-align: center;
      box-sizing: border-box;
      display: flex;
      align-content: center;
      align-items: center;
      justify-content:center;
    }
    .van-sidebar-item--select{
      background: var(--main-color);
      color:#fff;
      border:none;
      &::before{
        display: none;
      }
    }
  }
  .title {
    font-weight: 600;
    @extend .font9;
  }
}


.list{
  padding:50px 0 0 !important;
  &.portrait-list{
    background: #ffffff;
    .van-list {
      .s-grid-box{
        width: 100%;
        display: grid;
        grid-template-columns: repeat(3, 33.3%);
        align-items: start;
      }
    }
    .service-name{
      height: 44px;
      line-height: 22px;
      display: -webkit-box;
      overflow: hidden;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
    }
  }
  &.landscape-list{
    .van-list{
      padding:15px;
    }
  }
}
.empty{
  margin-top: 100px;
}
.empty-container {
  width: 100%;
}
.van-pull-refresh{
  overflow: auto;
}
.van-pull-refresh .van-pull-refresh__track {
  height: inherit;
}

</style>
